import styled from '@emotion/styled';

import { colors } from '../../../../theme';

const S = {
    Root: styled('div')({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        paddingLeft: '24px',
        backgroundColor: colors.black2,
        flexDirection: 'column',
        gap: '10px',
        marginTop: '10px',
        marginBottom: '10px'
    }),
    labelTitle: {
        height: '17px',
        marginTop: '14px',
        color: colors.white90,
        fontWeight: '600',
        fontFamily: 'Inter',
        fontSize: '14px',
        lineHeight: '16.94px'
    },
    labelInstructions: {
        color: colors.white30,
        fontWeight: '400',
        fontFamily: 'Inter',
        fontSize: '13px',
        lineHeight: '23px'
    },
    input: {
        backgroundColor: colors.blackRock,
        padding: '20px',
        color: colors.white90,
        border: `0.5px solid ${colors.white10}`,
        paddingRight: '2rem'
    }
};

export default S;
